import { SolaView, htmlSolaWithInstance } from '@hm-spt/sola';

interface NotFoundData {}

export class NotFoundView extends SolaView<NotFoundData> {
  constructor() {
    super();
    this.data = {};
  }

  override getTitle(): string {
    return '페이지 없음 — HCLTech 어드민';
  }

  render(): HTMLElement {
    return htmlSolaWithInstance(this)`
      <div class="page page-404">
        <div class="not-found">
          <h1>404</h1>
          <p>요청하신 페이지가 없습니다.</p>
          <a class="btn-primary" data-link href="/">대시보드로 돌아가기</a>
        </div>
      </div>
    `;
  }
}
